"use client";

import { motion } from "framer-motion";
import Image from "next/image";
import Container from "@/components/ui/Container";

const features = [
  {
    image: "/images/001_intuitiva.png",
    title: "Intuitiva",
    description: "Interfaz intuitiva para todos los niveles de usuarios."
  },
  {
    image: "/images/002_gestionable.png",
    title: "Gestionable",
    description: "Gestionar roles y estructuras."
  },
  {
    image: "/images/003_adaptable.png",
    title: "Adaptable",
    description: "Adapte la aplicación a diferentes tipos de cultivos y condiciones."
  }
];

export default function KeyBenefits() {
  return (
    <section
      style={{
        background: "url('/images/Bloom-Wise_feactures-app_background.webp') lightgray 50% / cover no-repeat",
        minHeight: "623px",
        paddingTop: "150px",
        paddingBottom: "80px"
      }}
    >
      <Container>
        <div className="grid lg:grid-cols-3 gap-8" style={{ maxWidth: "1200px", margin: "0 auto" }}>
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="text-center"
            >
              {/* Image */}
              <div className="w-32 h-32 md:w-40 md:h-40 lg:w-48 lg:h-48 mx-auto mb-6 relative">
                <Image
                  src={feature.image}
                  alt={feature.title}
                  fill
                  className="object-contain"
                />
              </div>

              {/* Title */}
              <h3
                className="mb-3 text-[28px] md:text-[32px] lg:text-[40px]"
                style={{
                  alignSelf: 'stretch',
                  color: '#212529',
                  textAlign: 'center',
                  fontWeight: 400,
                  lineHeight: '1.25',
                }}
              >
                {feature.title}
              </h3>

              {/* Description */}
              <p
                className="text-[16px] md:text-[18px] lg:text-[20px]"
                style={{
                  alignSelf: 'stretch',
                  color: '#212529',
                  textAlign: 'center',
                  fontWeight: 400,
                  lineHeight: '1.3',
                }}
              >
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </Container>
    </section>
  );
}
